/**
 * @desc 这部分存放全部的请求地址
 */
const apiConfig = {
    /** suixinhuan 单独模块：获取场次监控会员记录 */
    getVipRecord: '/userApi/getVipRecord.json',
    getOpenAppCount: '/userApi/getOpenAppCount.json',
    /** uniApi 单独模块 */
    getCarImgesData: '/api/CarData/GetReportBannerPhotoInfo',
    getFieldConfigList: '/userService/RestServices/KeyValueService.svc/GetFieldConfigList',
    saveFieldConfigList: '/userService/RestServices/KeyValueService.svc/SaveFieldConfigList',
    /** auction 竞拍核心模块*/
    createSession: '/auctionRoundApi/create.json',
    updateRoundRule: '/auctionRoundApi/updateRoundRule.json',
    getAuctionBaseInfo: '/auctionBaseInfoApi/getAuctionInfo.json',
    setAuctionFailed: '/carManageStateApi/setAuctionFailed.json',
    editGoods: '/auctioningGoodsAPi/update.json',
    removeGoods: '/auctionRoundApi/removeGoods.json',
    editSerialNumber: '/auctioningGoodsApi/editSerialNumber.json',
    moveGoods: '/auctioningGoodsAPi/move.json',
    selectTakeOff: '/auctioningGoodsApi/selectTakeOff.json',
    selectHigherBasePrice: '/auctioningGoodsApi/selectHigherBasePrice.json',
    isAuctionLast: '/auctionRoundApi/isAuctionLast.json',
    isTwoMinLeft: '/auctionRoundApi/isTwoMinLeft.json',
    getSessionDetails: '/auctionRoundApi/detail.json',
    getByRoundId: '/auctionRoundApi/queryByRoundId.json',
    addGoodsList: '/auctionRoundApi/addGoodsList.json',
    queryByRoundId: '/auctionRoundApi/queryByRoundId.json',
    getMiniCode: '/auctionRoundApi/getMiniCode.json',
    save: '/auctionRoundApi/save.json',
    send: '/auctionRoundApi/send.json',
    addFlapperInfo: '/bidderApi/addFlapperInfo.json',
    existFlapper: '/bidderApi/existFlapper.json',
    bid: '/bidderApi/bid.json',
    getAuctionInfo: '/bidderApi/getAuctionInfo.json',
    getNextAuctionInfo: '/bidderApi/getNextAuctionInfo.json',
    biddingOperation: '/bidderApi/biddingOperation.json',
    getAuctionResult: '/bidderApi/getAuctionResult.json',
    cancelPerAuctionResult: '/bidderApi/cancelPerAuctionResult.json',
    querySessionPosition: '/roundAddressMaintainApi/getList.json',
    auctionCount: '/homePageAuctionCountApi/auctionCount.json',
    getAuctionStateList: '/carManageStateApi/getAuctionStateList.json',
    bidRecord: '/auctioningGoodsAPi/bidRecord.json',
    getCommissionRecordPage: '/commissionSetApi/getCommissionRecordPage.json',
    getBrokerageRecordPage: '/brokerageSetApi/getBrokerageRecordPage.json',
    getAuctionTradeList: '/carManageStateApi/getAuctionTradeList.json',
    dealAuction: '/carManageStateApi/dealAuction.json',
    auctionExport: '/exportApi/export.json',
    auctionExportSort: '/exportApi/exportEditSerialNumber.json',
    auctionLeadInSort: '/auctioningGoodsApi/importSort.json',
    confirmFailTrade: '/goodsOperateApi/tradeFailedById.json',
    auctioneerDetail: '/auctioneerApi/getDetail.json',
    startAuction: '/auctioneerApi/startAuction.json',
    stopAuction: '/auctioneerApi/pauseAuction.json',
    goOnAuction: '/auctioneerApi/continueAuction.json',
    endAuction: '/auctioneerApi/endAuction.json',
    startCountDown: '/auctioneerApi/startCountDown.json',
    continueCountDown: '/auctioneerApi/continueCountDown.json',
    pauseCountDown: '/auctioneerApi/pauseCountDown.json',
    clinch: '/auctioneerApi/clinch.json',
    failAuction: '/auctioneerApi/failAuction.json',
    pendingTransaction: '/auctioneerApi/pendingTransaction.json',
    inquiryPrice: '/auctioneerApi/inquiryPrice.json',
    queryPageAuctioningGoods: '/auctioningGoodsAPi/queryPage.json',
    takeOffAuctioningGoods: '/auctioningGoodsAPi/takeOff.json',
    getBrokerageInfo: '/brokerageSetApi/getBrokeragePage.json',
    getCarTypeList: '/brokerageSetApi/getCarTypeList.json',
    editBrokerage: '/brokerageSetApi/edit.json',
    getCommissionInfo: '/commissionSetApi/getCommissionPage.json',
    getCommissionRecordList: '/commissionSetApi/getCommissionRecordPage.json',
    editCommission: '/commissionSetApi/edit.json',
    queryRoundAddress: '/roundAddressMaintainApi/query.json',
    editRoundAddress: '/roundAddressMaintainApi/edit.json',
    delRoundAddress: '/roundAddressMaintainApi/del.json',
    queryFrontContent: '/frontContentApi/query.json',
    updateFrontContent: '/frontContentApi/update.json',
    queryPageAuctionRound: '/auctionRoundApi/queryPage.json',
    cancelPageAuctionRound: '/auctionRoundApi/cancel.json',
    getScreenDetail: '/screenApi/getScreenDetail.json',
    hasEndOfTheAuction: '/appletsApi/hasEndOfTheAuction.json',
    addBuyerInfo: '/carManageStateApi/addBuyerInfo.json',
    getDefaultCommission: '/commissionSetApi/getDefaultCommissionAndBrokerage.json',
    deletePageAuctionRound: '/auctionRoundApi/remove.json',
    getCommissionRecord: '/brokerageSetApi/getBrokerageRecord.json',
    getServiceRecord: '/commissionSetApi/getCommission.json',
    getScenePrinting: '/auctionRoundApi/detail.json',
    delBrokerageRecord: '/brokerageSetApi/delBrokerageRecord.json',
    brokerageSetDefaultTag: '/brokerageSetApi/setDefaultTag.json',
    delCommissionRecord: '/commissionSetApi/delCommissionRecord.json',
    commissionSetDefaultTag: '/commissionSetApi/setDefaultTag.json',
    buyerBidRecord: '/buyerBehaviorRecordApi/buyerBidRecord.json',
    auctionRoundDetail: '/auctionRoundApi/detail.json',
    queryRoundStatusNum: '/auctionRoundApi/queryRoundStatusNum.json',
    roundMonitorTabDataCount: '/roundMonitorDataApi/roundMonitorTabDataCount.json',
    queryAuctionRecordPage: '/auctionBaseInfoApi/queryAuctionRecordPage.json',
    cancelBid: '/auctioningGoodsAPi/cancelBid.json',
    // 玩法规则
    getAuctionPlayRule: '/auctionPlayRuleSetApi/getAuctionPlayRule.json',
    getAuctionPlayRuleById: '/auctionPlayRuleSetApi/getAuctionPlayRuleById.json',
    saveOrUpdatePlayRule: '/auctionPlayRuleSetApi/saveOrUpdate.json',
    getBrokerageList: '/brokerageSetApi/getBrokeragePage.json',
    getCommissionList: '/commissionSetApi/getCommissionPage.json',
    getAuctionPlayRuleList: '/auctionPlayRuleSetApi/queryPage.json',
    getPlayRulesByPage: '/auctionPlayRuleSetApi/queryPage.json',
    delAuctionPlayRule: '/auctionPlayRuleSetApi/delAuctionPlayRule.json',
    setDefaultPlayRule: '/auctionPlayRuleSetApi/setDefaultTag.json',
    getPlayRulesRecordPage: '/auctionPlayRuleSetApi/getPlayRuleEditLog.json',
    // 竞拍公共规则
    getCommonRule: '/commonRuleApi/getCommonRule.json',
    saveCommonRule: '/commonRuleApi/save.json',
    editCommonRule: '/commonRuleApi/edit.json',
    auctionEnd: '/auctioneerApi/auctionEnd.json',
    savePlayRules: '/auctionPlayRuleSetApi/saveOrUpdate.json',
    getPlayRules: '/auctionPlayRuleSetApi/getAuctionPlayRule.json',
    getCustomPriceButton: '/bidderApi/getCustomPriceButton.json',
    // 竞拍管理
    getBidSession: '/roundMonitorDataApi/queryPage.json',
    roundMonitorInfo: '/roundMonitorDataApi/roundMonitorDataDetail.json',
    roundMonitorList: '/auctionMonitorApi/select.json',
    // 实时监控
    auctionRealTimeMonitor: '/auctionMonitorApi/auctionRealTimeMonitor.json',
    queryBrowerPage: '/buyerBehaviorRecordApi/queryBrowerPage.json',
    queryFocusPage: '/buyerBehaviorRecordApi/queryFocusPage.json',
    /** user 用户模块 */
    buyerDetail: '/dealerManageAction/getBuyerDealerDetail.json',
    sellerDetail: '/dealerManageAction/getSellerDealerDetail.json',
    searchDealers: '/dealerManageAction/getBuyerDealerDetailByName.json',
    buyerList: '/dealerManageAction/buyerList.json',
    RealNameAuthenticated: '/registerUserManageAction/realNameAuthenticated.json',
    getVerificationCode: '/registerUserManageAction/getVerificationCode.json',
    checkVerificationCode: '/registerUserManageAction/checkVerificationCode.json',
    checkCodeAndRealNamefromWxUser: '/registerUserManageAction/checkCodeAndRealNamefromWxUser.json',
    deleteNumberPlate: '/numberPlateManageAction/deleteNumberPlate.json',
    deleteNumberPlateByTenantCode: '/numberPlateManageAction/deleteNumberPlateByTenantCode.json',
    editNumberPlate: '/numberPlateManageAction/editNumberPlate.json',
    insertNumberPlate: '/numberPlateManageAction/insertNumberPlate.json',
    operationBuyerInfo: '/dealerManageAction/operationBuyerInfo.json',
    editUserMsg: '',
    queryBankList: '/bankManageAction/queryBankList.json',
    userExport: '/bankManageAction/queryBankList.json',
    queryDealerPage: '/dealerManageAction/queryDealerPage.json',
    queryDealerList: '/dealerManageAction/getSellerDealerList.json',
    getAllGroupName: '/dealerManageAction/getAllGroupName.json',
    getAccount: '/accountManageAction/getAccount.json',
    changePassword: '/accountManageAction/changePassword.json',
    editAccount: '/accountManageAction/editAccount.json',
    getAuthZ: '/userApi/getResource.json',
    // queryAccountList: '/accountManageAction/queryAccountList.json', // 获取分配人员列表 - 无权限
    queryAccountList: '/accountManageAction/getUserListByResCode.json',
    logout: '/userLoginApi/logout.json',
    getTenantInfoAndArea: '/tenantInfoApi/getTenantInfoAndArea.json',
    saveTenantInfo: '/tenantInfoApi/saveTenantInfo.json',
    changeAsyncState: '/dealerManageAction/setShowBuyToSeller.json',
    /** order 订单模块 */
    disputeReason: '/dispute/disputeManagerApi/getDisputeReason.json',
    buyTransData: '/orderoperate/carOrderOperateApi/commitAuditingTransferDataApi.json',
    submitModificationResult: '/orderoperate/carOrderOperateApi/submitModificationResult.json',
    confirmGiveCar: '/orderoperate/carOrderOperateApi/sellerCommitDelivery.json',
    checkDisputeReason: '/dispute/disputeManagerApi/getSyncAuctionDisputeReason.json',
    daYuDisputeReason: '/dispute/disputeManagerApi/optDisputeSellerBreach.json',
    dealDetail: '/dispute/disputeManagerApi/getDisputeOptionDetail.json',
    getUploadPicTempl: '/orderoperate/carOrderOperateApi/getCommitTransferDataModelApi.json',
    saveTransInfo: '/orderoperate/carOrderOperateApi/commitTransferDataApi.json',
    getOrderList: '/orderservice/orderServceViewApi/getOrderViewList.json',
    getWaitSignList: '/orderview/carOrderViewApi/getOrderTBCViewList.json',
    getDisputeListPage: '/dispute/disputeManagerApi/getDisputeListPage.json',
    getApplyPayMoney: '/orderoperate/carOrderOperateApi/buyerPaymentApplyForApi.json',
    getOrderPendingViewList: '/orderview/carOrderViewApi/getOrderPendingViewList.json',
    queryContractConfirmInfo: '/contract/contractApi/queryContractConfirmInfo.json',
    getOrderAll: '/orderview/carOrderViewApi/getBuyerPaymentAllList.json',
    getOrderNoPay: '/orderview/carOrderViewApi/getBuyerPayViewList.json',
    getDealPayTransfer: '/dispute/disputeManagerApi/applySyncAuctionDispute.json',
    getOrderTBRViewList: '/orderview/carOrderViewApi/getBuyerTBRViewList.json',
    getOrderTBCViewList: '/orderview/carOrderViewApi/getSellerPendingViewList.json',
    getOrderTradeFailViewList: '/orderview/carOrderViewApi/getSellerPendingFailViewList.json',
    getOrderSuccessView: '/orderview/carOrderViewApi/getSellerPendingSufViewList.json',
    querySignedContract: '/contract/contractApi/querySignedContract.json',
    queryTransferInfo: '/orderoperate/carOrderOperateApi/confirmTransferDataApi.json',
    buyerRecConfirm: '/orderconfirm/buyerRecConfirmApi/save.json',
    sellerPayReject: '/orderconfirm/sellerPayConfirmApi/rejectPay.json',
    sellerPayConfirm: '/orderconfirm/sellerPayConfirmApi/save.json',
    sellerPayment: '/orderconfirm/sellerPayConfirmApi/sellerPayment.json',
    orderExport: '/export/exportApi/export.json',
    getSignQRCode: '/contract/contractApi/getSignQRCode.json',
    brokeredDeal: '/orderoperate/carOrderOperateApi/matchUpCreateOrderOperateApi.json',
    confirmTransfer: '/orderview/carOrderViewApi/confirmationTransfer.json',
    TransferOtherFeel: '/orderview/carOrderViewApi/getOrderOtherFeeInfo.json',
    applicationSellerPay: '/orderview/carOrderViewApi/applicationSellerPay.json',
    WaitTransferCarList: '/orderview/carOrderViewApi/getOrderTBRViewList.json',
    TradeSuccessCarList: '/orderview/carOrderViewApi/getOrderTradeSuccessViewList.json',
    getWaitPayCarList: '/orderview/carOrderViewApi/getOrderPayViewList.json',
    getDisputeType: '/dispute/disputeTypeApi/getTypesBySourceCoce.json',
    getDisputeChildType: '/dispute/disputeTypeApi/getListByTypeAndSource.json',
    getOpenType: '/dispute/disputeTypeApi/getDisputeSources.json',
    submitDisputeApply: '/dispute/disputeManagerApi/saveDisputeApply.json',
    orderFailure: '/orderservice/orderServceApi/orderFailure.json',
    buyerDefault: '/dispute/disputeManagerApi/optDisputeBuyerBreach.json',
    sellerDefault: '/dispute/disputeManagerApi/optDisputeSellerBreach.json',
    tradeContinue: '/dispute/disputeManagerApi/optDisputeTradeContinue.json',
    dealTransDetail: '/dispute/disputeManagerApi/saveSyncAuctionDisputeProc.json',
    disputeTradeFailure: '/dispute/disputeManagerApi/optDisputeTradeFailure.json',
    getDisputeSources: '/dispute/disputeTypeApi/getDisputeSources.json',
    findByPage: '/dispute/disputeTypeApi/findByPage.json',
    daYuDisputeManage: '/dispute/disputeManagerApi/getSyncAuctionDisputeProcResult.json',
    getTypesBySourceCoce: '/dispute/disputeTypeApi/getTypesBySourceCoce.json',
    saveDisputeType: '/dispute/disputeTypeApi/save.json',
    deleteById: '/dispute/disputeTypeApi/deleteById.json',
    getOrderTradeFailList: '/orderview/carOrderViewApi/getOrderTradeFailViewList.json',
    getUserDepositBalance: '/dispute/disputeManagerApi/getUserDepositBalance.json',
    getOrderPaymentAmount: '/orderview/carOrderViewApi/getOrderPaymentAmount.json',
    getSellerPendingAllList: '/orderview/carOrderViewApi/getSellerPendingAllList.json',
    skipSignContract: '/contract/contractApi/orderPassContract.json',
    sellerBatchMoney: '/orderview/carOrderViewApi/getOrderBatchPayment.json',
    sellerBatchConfirm: '/orderconfirm/sellerPayConfirmApi/orderBatchPayment.json',
    winBiddingCarTable: '/orderview/carOrderViewApi/getOrderWinTenderViewList.json',
    getMatchUp: '/orderoperate/carOrderOperateApi/submitWinTenderMatchUpResult.json',
    normalDeal: '/orderoperate/carOrderOperateApi/submitWinTenderTransactionResult.json',
    breakContract: '/breach/breachOperateApi/luanchBreach.json',
    dealBreakContract: '/breach/breachOperateApi/auditPassBreachInfo.json',
    getOrderCountInfoApi: '/orderview/carOrderViewApi/getOrderCountInfoApi.json',
    getProcurementInfo: '/procurement/procurementInfoApi/getProcurementInfo.json',
    /** finance 财务模块 */
    remitDetail: '/sellerPayApi/sellerInfo.json',
    payDetail: '/buyerPayApi/buyerInfo.json',
    deposit: '/depositWithdrawApi/detail.json',
    singleBuyerMoney: '/buyerDepositApi/balance.json',
    singleSellerMoney: '/sellerDepositApi/balance.json',
    allBuyerMoney: '/buyerDepositApi/balanceTotal.json',
    allSellerMoney: '/sellerDepositApi/balanceTotal.json',
    buyerDepositList: '/buyerDepositApi/list.json',
    sellerDepositList: '/sellerDepositApi/list.json',
    buyerDepositDetailList: '/buyerDepositApi/optDetailList.json',
    sellerDepositDetailList: '/sellerDepositApi/optDetailList.json',
    buyerCharge: '/buyerDepositApi/charge.json',
    sellerCharge: '/sellerDepositApi/charge.json',
    buyerRefund: '/buyerDepositApi/refund.json',
    sellerRefund: '/sellerDepositApi/refund.json',
    applyRefund: '/depositWithdrawApi/accept.json',
    financeExport: '/exportApi/exportExcel.json',
    depositWithdrawList: '/depositWithdrawApi/list.json',
    rejectDepositWithdraw: '/depositWithdrawApi/reject.json',
    acceptDepositWithdraw: '/depositWithdrawApi/accept.json',
    selectAccountSumList: '/accountSumApi/selectAccountSumList.json',
    selectAccountDetailList: '/accountDetailApi/selectAccountDetailList.json',
    selectMarginSumList: '/gmsDepositApi/list.json',
    cancelBuyerPay: '/buyerPayApi/cancelBuyerPay.json',
    confirmBuyerPay: '/buyerPayApi/confirmBuyerPay.json',
    /** goods 竞拍模块*/
    getTabStatisticsCount: '/carStatisticApi/getTabStatisticsCount.json',
    getApplyCarCount: '/carStatisticApi/getApplyCarCount.json',
    getDealedCarCount: '/carStatisticApi/getDealedCarCount.json',
    getIndexList: '/carStatisticApi/getIndexList.json',
    queryCar: '/goodsListApi/getCarList.json',
    queryApproveCar: '/goodsListApi/getAuditList.json',
    queryMyGoodsAuditList: '/goodsListApi/queryMyGoodsAuditList.json',
    distributionAudit: '/goodsOperateApi/distributionAudit.json',
    throughApprove: '/goodsOperateApi/approvalAuditByIdList.json',
    disapprovalAuditById: '/goodsOperateApi/disapprovalAuditById.json',
    revocationAuditById: '/goodsOperateApi/revocationAuditById.json',
    getCarInfoListByAuditStatus: '/goodsListApi/getCarInfoListByAuditStatus.json',
    getCarInfoListByStatus: '/goodsListApi/getCarInfoListByStatus.json',
    queryCarLossListByGoodsId: '/goodsListApi/queryCarLossListByGoodsId.json',
    getCarInfoByGoodsId: '/goodsListApi/getCarInfoByGoodsId.json',
    goodsExport: '/exportApi/export.json',
    flowAuctionList: '/goodsListApi/queryAuctionFailed.json',
    getTradeFailedCars: '/goodsListApi/getTradeFailedCars.json',
    backAbortiveByIdList: '/goodsOperateApi/backAbortiveByIdList.json',
    getTradeSuccessedCars: '/goodsListApi/getTradeSuccessedCars.json',
    getOffLineCars: '/goodsListApi/getOffLineCars.json',
    getCustomerServiceByGoodsId: '/goodsListApi/getCustomerServiceByGoodsId.json',
    /** System 系统配置模块*/
    getBannerList: '/banner/bannerApi/findByPage.json',
    getBannerInfo: '/banner/bannerApi/findById.json',
    onShelves: '/banner/bannerApi/upShelf.json',
    offShelves: '/banner/bannerApi/downShelf.json',
    createBanner: '/banner/bannerApi/save.json',
    editBanner: '/banner/bannerApi/edit.json',
    uploadPic: '/banner/bannerApi/uploadPic.json',
    systemExport: '/banner/bannerApi/uploadPic.json',
    /** base 基础服务模块*/
    getProvince: '/carLocationApi/getProvinceList.json',
    getCity: '/carLocationApi/getCityList.json',
    getKeyValue: '/keyValueApi/getKeyValueListByTypeId.json',
    uploadImage: '/uploadApi/uploadImage.json',
    orderUploadImage: '/uploadApi/uploadPicOss.json',
    baseExport: '/uploadApi/uploadImage.json',
    getKeyValueListByTypeId: '/keyValueApi/getKeyValueListByTypeId.json',
    getSellerPayConfig: '/sellerPayConfigApi/getSellerPayConfig.json',
    createSellerPayConfig: '/sellerPayConfigApi/createSellerPayConfig.json',
    modifySellerPayConfig: '/sellerPayConfigApi/modifySellerPayConfig.json',
    getTransferFrozenMoney: '/transferFrozenMoneyApi/getTransferFrozenMoney.json',
    saveTransferFrozenMoney: '/transferFrozenMoneyApi/saveTransferFrozenMoney.json',
    savePaymentWorkFlowConf: '/orderBaseConfigApi/paymentWorkFlowConfiguration.json',
    getPaymentWorkFlowConf: '/orderBaseConfigApi/selectPaymentWorkFlowConfiguration.json',
    getKeyValueListByQueries: '/keyValueApi/getKeyValueListByQueries.json',
    setKeyValueOperate: '/keyValueApi/setKeyValueOperate.json',
    updateKeyValueOperate: '/keyValueApi/updateKeyValueOperate.json',
    /** report 数据报表模块 */
    reportList: '/reportFormDetailApi/queryPage.json',
    deleteReportForm: '/reportFormDetailApi/deleteReportForm.json',
    createReport: '/exportReportApi/create.json',
    homeDataPreview: '/batchAdvanTentStatApi/getStatByHome.json',
    reportConfig: '/reportFormDetailApi/find.json',
    repostDataQuery: '/batchAdvanTentStatApi/getReportDataByPreview.json',
    roundListQuery: '/roundInfoApi/queryPage.json',
    queryPreView: '/batchAdvanTentStatApi/getReportDataByConditions.json',
    reportExport: '/exportReportApi/export.json',
};
export default apiConfig;
